class FlashMessage {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.flashContainer = self.elem.querySelector("[data-flash-message]");
        self.flashMessage = sessionStorage.getItem("flashMessage");
    }

    init() {
        let self = this;

        if (self.flashMessage && self.flashContainer) {
            self.flashContainer.textContent = self.flashMessage;
            self.flashContainer.classList.remove("hidden");
            
            sessionStorage.removeItem("flashMessage");
        }

        setTimeout(() => {
            if (self.flashContainer && self.flashContainer.classList) {
                self.flashContainer.classList.add("hidden");
            }
        }, 5000);
    }
}

export default FlashMessage;